import { format, isToday } from 'date-fns';
import { formatMessengerActivityLabel } from '@/components/Messenger/shared/messengerActivityDateLabel';

export function directMessageLocalDayKey(iso: string): string {
  return format(new Date(iso), 'yyyy-MM-dd');
}

export function isDirectMessageDayToday(iso: string): boolean {
  return isToday(new Date(iso));
}

export function formatDirectChatDayDividerLabel(iso: string): string {
  return formatMessengerActivityLabel(iso, { includeTime: false });
}
